import {useEffect, useState} from 'react';

import {useStores} from '../stores/use-stores';

import useIsLoggedIn from './useIsLoggedIn';

export default function useStorePriceDisplayConditions() {
  const {userStore, rewardsStore, shopSelectionStore} = useStores();
  const isLoggedIn = useIsLoggedIn();
  const [isRewardsMember, setIsRewardsMember] = useState(false);
  const [selectedShopLoyaltyEnabled, setSelectedShopLoyaltyEnabled] = useState(false);

  useEffect(() => {
    setIsRewardsMember(rewardsStore.hasRewards);
    setSelectedShopLoyaltyEnabled(shopSelectionStore.loyaltyEnabled);
  }, [userStore, userStore.sessionToken, rewardsStore.hasRewards, shopSelectionStore.loyaltyEnabled]);

  const storePriceDisplayConditions = {
    showMemberPrice: {
      publicPricing: selectedShopLoyaltyEnabled,
      privatePricing: selectedShopLoyaltyEnabled && isRewardsMember && isLoggedIn,
    },
    priceDisplayConditions: {
      isLoggedIn,
      isRewardsMember,
      selectedShopLoyaltyEnabled, 
    }
  };

  return storePriceDisplayConditions;
}
